import {post} from './httpBase'

//获取起止区域列表
export function lineList(params) {
    return post('/line/line/dispatcher', params)
}
//获取司机列表
export function driverList(params) {
    return post('/user/driver/dispatcher', params)
}
//获取车辆列表
export function carList(params) {
    return post('/user/car/driverdispatcher', params)
}
//获取价格模板
export function priceModel(params) {
    return post('/line/pricetemplate/line', params)
}
//获取运行时间模板
export function runTimeModel(params) {
    return post('/line/runtimetemplate/line', params)
}
//添加排班
export function addShift(params) {
    return post('/line/shift', params)
}
//行程详情
export function shiftDetail(params) {
    return post('/line/shift/detail/dispatcher', params)
}
//锁定出行位置
export function lockSeat(params) {
    return post('/line/seat/lock', params)
}
//解锁出行位置
export function unlockSeat(params) {
    return post('/line/seat/unlock', params)
}
//更换司机
export function changeDriver(params) {
    return post('/line/shift/changedriver', params)
}
//获取更换司机的列表
export function getChangeDriver(params) {
    return post('/user/driver/drivercar', params)
}
//获取乘客详情
export function passengerInfo(params) {
    return post('/order/intercity/seat', params)
}
//根据调度人员查询改签行程
export function changeShiftList(params) {
    return post('/line/shift/search', params)
}
//获取改签行程详情
export function changeOrderInfo(params) {
    return post('/line/shift/detail', params)
}
//获取改签订单价格
export function getChangeOrderPrice(params) {
    return post('/order/intercity/endorse/charge', params)
}
//确认改签
export function changeOrder(params) {
    return post('/order/intercity/endorse', params)
}
//获取退款手续费
export function getRefundPrice(params) {
    return post('/order/intercity/refund/charge', params)
}
//确认退票
export function refund(params) {
    return post('/order/intercity/refund/driverdispatcher', params)
}
//退款详情
export function refundDetail(params) {
    return post('/order/intercity/refund/detail', params)
}
//乘客明细列表
export function passengers(params) {
    return post('/order/intercity/passengers', params)
}
//修改地址按钮检查,判断当前订单是否有人在更改
export function changeAddress(params) {
    return post('/order/shuntorder/changeaddressofshuntorderbefore', params)
}
//支付检查接口
export function checkPay(params) {
    return post('/order/shuntorder/cheakpaystatus', params)
}
//取消地址修改
export function dismissAddress(params) {
    return post('/order/shuntorder/canceladdresschange', params)
}

//批量排班
export function batchShift(params) {
    return post('/line/shift/batch', params)
}
//批量删除排班
export function batchDelete(params) {
    return post('/line/shift/batchDelete', params)
}
//带货订单列表
export function goodsList(params) {
    return post('/order/logistics/listofshift', params)
}
//确认取货
export function receiving(params) {
    return post('/order/logistics/receiving', params)
}
//确认收货
export function debus(params) {
    return post('/order/logistics/debus', params)
}


// WEBPACK FOOTER //
// ./src/service/shiftService.js